import { Classes as CoreClasses } from "@blueprintjs/core";

/* eslint-disable tree-shaking/no-side-effects-in-initialization */
const NS = CoreClasses.getClassNamespace();
export const TIMEZONE_SELECT = `${NS}-timezone-select`;
export const TIMEZONE_SELECT_POPOVER = `${TIMEZONE_SELECT}-popover`;

export const Classes = {
  TIMEZONE_SELECT,
  TIMEZONE_SELECT_POPOVER,
};
